import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ILeaseListVariables, ILeaseConnectionWithTotal } from '@api'
import { parseContract } from '.'
import { LeaseFragment } from '@api/fragments'

export default function list(variables: ILeaseListVariables): Promise<ILeaseConnectionWithTotal> {
  return client.gql.query({ query, variables }).then(
    ({
      data: {
        viewer: {
          company: { contracts },
        },
      },
    }: any) => {
      for (const edge of contracts.edges) edge.node = parseContract(edge.node)
      return contracts
    }
  )
}

export function csv(variables: ILeaseListVariables): Promise<ILeaseConnectionWithTotal> {
  return client.gql.query({ query: csvQuery, variables }).then(
    ({
      data: {
        viewer: {
          company: { contracts },
        },
      },
    }: any) => {
      return contracts
    }
  )
}

const query = gql`
  query Leases(
    $first: Int
    $after: String
    $sortBy: ContractSortBy
    $order: ContractOrder
    $keyValueFilters: [ContractKeyValueFiltersInput]
    $dateFilters: [ContractDateFiltersInput]
    $cities: [String]
    $query: String
  ) {
    viewer {
      company {
        contracts(
          first: $first
          after: $after
          sortBy: $sortBy
          order: $order
          keyValueFilters: $keyValueFilters
          dateFilters: $dateFilters
          cities: $cities
          query: $query
          type: Lease
          includeOldBuildings: true
        ) {
          pageInfo {
            endCursor
            hasNextPage
          }
          counters {
            leases
            floors
            buildings
            totalAnnualCost
          }
          edges {
            node {
              ...LeaseFragment
            }
          }
        }
      }
    }
  }
  ${LeaseFragment}
`

const csvQuery = gql`
  query Leases(
    $first: Int
    $after: String
    $sortBy: ContractSortBy
    $order: ContractOrder
    $keyValueFilters: [ContractKeyValueFiltersInput]
    $dateFilters: [ContractDateFiltersInput]
    $cities: [String]
    $query: String
  ) {
    viewer {
      company {
        contracts(
          first: $first
          after: $after
          sortBy: $sortBy
          order: $order
          keyValueFilters: $keyValueFilters
          dateFilters: $dateFilters
          cities: $cities
          query: $query
          type: Lease
        ) {
          exportList
        }
      }
    }
  }
`
